module.exports = __webpack_public_path__ + "img/6.7-Table-Grouped.d55d9cfe.png";